import { combineReducers } from "redux";

function menus(state = [], action) {
  switch (action.type) {
    case 'SET_MENUS':
      return action.menus || null
    default:
      return state
  }
}

function roles(state = [], action) {
  switch (action.type) {
    case 'SET_ROLES':
      return action.roles || null
    default:
      return state
  }
}

function operator(state = '', action) {
  switch (action.type) {
    case 'SET_OPERATOR':
      return action.operator || null
    default:
      return state
  }
}

function roleId(state = '', action) {
  switch (action.type) {
    case 'SET_ROLEID':
      return action.roleId || null
    default:
      return state
  }
}

const reducer = combineReducers({
  menus,
  roles,
  operator,
  roleId
})

export default reducer